import React, { useEffect, useState } from 'react'
import HomeLayout from '../../../Layout/HomeLayout';
import DynamicHomeCard from '../../../CustomComponents/DynamicHomeCard';
import HomeHeader from '../../../CustomComponents/HomeHeader';
import { GetApiHeadersWithBearer, GetRequest } from '../../../../network/NetworkUtils';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AccountDetailsHeder, addLineBreaks, copyToClipboard, MoreServices, QuickActions } from '../../../../utils';
import { SAVINGS, GET_DDA_DETAILS, GET_DDA_DOWNLOAD_URL, STATUS_SUCCESS_CODE, PAID_PROMO_KEY } from '../../../../network/URLConstants';
import { appTheme, retrieveData, showKudzuPlusPrompt } from '../../../../helpers/utils/Utils';
import { width } from '../../../CustomComponents/DynamicHomeCard/DynamicHomeCardStyles';
import DynamicCard from '../../../CustomComponents/DynamicHomeCard';
import FooterContent from '../../../CustomComponents/Footer';
import TransferImg from '../../../../assets/images/transfer.png';
import Shadowdollar from '../../../../assets/kudzu-plus-images/shadowdollar.png';
import { useNavigate } from 'react-router-dom';
import CustomModalPlus from '../../../../kudzu_plus/helpers/customModalPlus';
import MemnershipEnrollmentScreens from '../../../../kudzu_plus/components/membershipEnrollmentScreens';
import Cookies from 'js-cookie';
import logFirebaseEvents from '../../../LogFirebaseEvents';
import CardHeading from '../../../CustomComponents/CardHeading';
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle';

const AccountServicesSavingsCard = () => {
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
  const appThemeData = appTheme(kudzuPlusTrue)
  const { t } = useTranslation();
  const navigate = useNavigate();

  useDocumentTitle(t('page_title_savings_account_services'));

  const [checkingAccountNumber, setCheckingAccountNumber] = useState('*********'); //Account Number
  const [checkingRoutingNumber, setCheckingRoutingNumber] = useState('*********');
  const [savingAccountNumber, setSavingAccountNumber] = useState('*********'); //Account Number
  const [savingRoutingNumber, setSavingRoutingNumber] = useState('*********');
  const cards = useSelector(state => JSON.parse(state.userCards));
  const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
  const accessTokenToApi = useSelector(state => state.accessToken);
  const [accountCopied, setAccountCopied] = useState(false);
  const [routingCopied, setRoutingCopied] = useState(false);
  const [loading, setLoading] = useState(false)
  const [CardKey, setCardKey] = useState('')
  const dispatch = useDispatch();
  const currentpath = useLocation()




  const HighlightMsgStyles = "sm:w-auto w-[253px] font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal text-[#2965FB] cursor-pointer pointer-events-none";
  const HeaderMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal cursor-pointer pointer-events-none";
  const HeaderMsgStylesForPlus = "font-serif-pro text-white modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal cursor-pointer pointer-events-none";
  const summaryParagraphStyles = "font-hanken-grotesk modal-title text-white lg:text-[13px] md:text-[13px] sm:text-[6px] text-[8px] font-[400] cursor-pointer pointer-events-none";
  const SubHeaderMsgStyles = "font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none";
  const [highlightMsg, setHighlightMsg] = useState('')
  const [headerMsg, setheaderMsg] = useState('')
  const [subHeaderMsg, setSubHeaderMsg] = useState('')
  const [btn1Exists, setBtn1Exists] = useState(false)
  const [btn2Exists, setBtn2Exists] = useState(false)
  const [btn1Text, setBtn1Text] = useState(false)
  const [btn2Text, setBtn2Text] = useState('')
  const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
  const [modelImage, setModelImage] = useState('')
  const [isBorderNone, setisBorderNone] = useState(true);
  const [carousel, setCarousel] = useState('');
  const [summaryParagraph, setSummaryParagraph] = useState('');
  const [opacityValueLow, setOpacityValueLow] = useState(false);
  const [showPlusModal, setShowPlusModal] = useState(false);
  const [comparisonScreen, setComparisonScreen] = useState('');
  const [fullWidth, setFullWidth] = useState(false);
  const [footerButtonEnable, setFooterButtonEnable] = useState(false);
  const [gradientButton, setGradientButton] = useState(false);
  const [largeImage, setLargeImage] = useState(false);
  const [btn1BgColor, setBtn1BgColor] = useState("");
  const [showCarouselScreenShow, setShowCarouselScreensShow] = useState(false);





  const isShowKudzuPlusPrompt = showKudzuPlusPrompt(loggedResponse);
  const [promoKey,setPromoKey] = useState(loggedResponse?.Promos?.[0]?.PromoKey);
 
  useEffect(() => {
    dispatch({ type: 'SELECTED_SUB_INDEX', payload: { selectedSubIndex: -1 } });
    cards?.map((item) => {
      const { AccountTypeName, CardKey } = item;
      getAccountNumberDetails(AccountTypeName, CardKey);
      return null; // Return null from the map to avoid returning a new array
    });
  }, []);


  const getAccountNumberDetails = async (cardType, cardkey) => {
    // debugger;
    if (cardkey == undefined || cardkey == null) {
      return
    }
    setCardKey(cardkey)
    setLoading(true)
    let url = GET_DDA_DETAILS + cardkey;
    const deviceId = await retrieveData('updatedDeviceId');
    const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
    var response = await GetRequest(url, headers)
    setTimeout(() => {
      setLoading(false)
    }, 500);
    var responseObj = JSON.parse(response);
    if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
      if (responseObj.Response != undefined) {
        if (cardType == SAVINGS) {
          setCheckingAccountNumber(responseObj.Response.ExternalSVAID != undefined ? responseObj.Response.ExternalSVAID : '--');
          setCheckingRoutingNumber(responseObj.Response.RoutingNumber != undefined ? responseObj.Response.RoutingNumber : '--')
        } else {
          setSavingAccountNumber(responseObj.Response.ExternalSVAID != undefined ? responseObj.Response.ExternalSVAID : '--');
          setSavingRoutingNumber(responseObj.Response.RoutingNumber != undefined ? responseObj.Response.RoutingNumber : '--')
        }

      }
    } else {
      var arrMessages = responseObj.Messages;
      var message = arrMessages[0];
      var displayText = message.DisplayText;
    }
  }

  const transferMoneyClicked = () => {
    global.selectedAccountServiceCardKey = CardKey
    navigate('/AccountServices/Savings/TransferMoney')
  }

  const accountNumberCopiedClicked = () => {
    copyToClipboard(checkingAccountNumber, setAccountCopied(true))
    setAccountCopied(true);
    setTimeout(() => {
      setAccountCopied(false);
    }, 2000);

  }
  const routingNumberCopiedClicked = () => {
    copyToClipboard(checkingRoutingNumber, setRoutingCopied(true))
    setRoutingCopied(true);
    setTimeout(() => {
      setRoutingCopied(false);
    }, 2000);
  }

  ///Quick Actions

  const QuickActionsButtons = [
    { name: "Transfer Money", actionType: "", path: "/AccountServices/Savings/TransferMoney" },

  ]


  ///more services

  const moreServicesArray = [
    { name: 'Edit Account Name', actionType: '', path: '/AccountServices/Savings/EditAccountName' }
  ];



  const showAlertModalPlus = (showPlusModal, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, carousel, isBorderNone, btn1BgColor, summaryParagraph, opacityValue, comparisonScreen, fullWidth, footerButtonEnable, gradientButton, largeImage) => {
    setShowPlusModal(showPlusModal)
    setHighlightMsg(highlightMsg)
    setheaderMsg(headerMsg)
    setSubHeaderMsg(subHeaderMsg)
    setBtn1Exists(btn1Exists)
    setBtn2Exists(btn2Exists)
    setBtn1Text(btn1Text)
    setBtn2Text(btn2Text)
    setBtn1TypeAcpt(btn1TypeAcpt)
    setModelImage(modelImage)
    setBtn1Exists(btn1Exists)
    setBtn1Text(btn1Text)
    setCarousel(carousel)
    setisBorderNone(isBorderNone)
    setBtn1BgColor(btn1BgColor)
    setSummaryParagraph(summaryParagraph)
    setOpacityValueLow(opacityValue)
    setComparisonScreen(comparisonScreen)
    setFullWidth(fullWidth)
    setFooterButtonEnable(footerButtonEnable)
    setGradientButton(gradientButton)// gradient button for popup
    setLargeImage(largeImage)
  }

  const closeModelPlus = () => {
    setShowPlusModal(false)
    setShowCarouselScreensShow(false);
  }

  const onAcptBtnClickPlusModal = () => {
    logFirebaseEvents("Account_Services_Savings_Card", "Kudzu_Plus_Learn_More_Clicked", "Kudzu_Plus_Learn_More_Clicked", "", "");
    setShowPlusModal(false)
    const currentPath = { currentPathFromStore: currentpath.pathname };
    dispatch({ type: 'CURRENT_LOCATION', payload: currentPath });
    setShowCarouselScreensShow((prev) => !prev);
    const data = { kudzuFlowFrom: "fromAccountSavings" };
    dispatch({ type: 'KUDZU_PLUS_FROM', payload: data });
  }

  const onCancelBtnClickPlusModal = () => {
    logFirebaseEvents("Account_Services_Savings_Card", "Kudzu_Plus_No_Thanks_Clicked", "Kudzu_Plus_No_Thanks_Clicked", "", "");
    setShowPlusModal(false)
  }

  ////footer
  const kudzuPlusSavings = () => {
    return (
      <FooterContent highlightText={t("Earn_High-Yield_on_Savings_with_Kudzu+")}
        subHeaderText={addLineBreaks(t("Upgrade_Now_Savings"))}
        image={Shadowdollar} buttonEnabled={true}
        buttonText={t("learn_more")}
        type={t("kudzuPlusLearnMore")}
        borderDirection={'odd'}
        isSubheadingwidth={false}
        footerBtnAction={() => {
          dispatch({ type: 'CLIMB_POPUP_SHOWVALUE', payload: { climbPopShowValue: false } });
          setShowCarouselScreensShow(false);
         // showAlertModalPlus(true, t("thanks"), t("Try_a_Kudzu+_membership_for_three_months"), "", true, true, t('Learn_More'), t('No_Thanks'), true, require('../../../../assets/kudzu-plus-images/KudzuPluseLogo.png'), "", true, "#262B3A", t('first_three_months_charged_automatically'), true, '', false, false, true, true);
         showAlertModalPlus(true, 
          promoKey == PAID_PROMO_KEY ? "" : t("thanks"), 
          promoKey == PAID_PROMO_KEY ?  addLineBreaks(t('paid_access_exclusive_fature_and_benfits_when_you_join_kudzu_plus')) :t("Try_a_Kudzu+_membership_for_three_months"), 
          "", true, true, t('Learn_More'), t('No_Thanks'), true, require('../../../../assets/kudzu-plus-images/K-plus-logo.png'), "", true, "#262B3A",
          promoKey == PAID_PROMO_KEY ?  t('monthly_memebership_fee_will_be_automatically_deducted') : t('first_three_months_charged_automatically'),
            true, '', false, false, true, true);
          logFirebaseEvents("Account_Services_Savings_Card", "Savings_Kudzu_Plus_Learn_More_Clicked", "Savings_Kudzu_Plus_Learn_More_Clicked", "", "");
        }}
      />)
  }

  const footerContent = () => {
    return (
      <FooterContent highlightText={t("savingsCardHeding")}
        subHeaderText={t("savingCardSubheading")}
        image={appThemeData.TransferImg} 
        buttonEnabled={true}
        buttonText={t("savingCardBtn")}
        footerBtnAction={transferMoneyClicked}
        type={t("savingCardBtn")}
        isSubheadingwidth={true}
        btnBgColor={kudzuPlusTrue ? "borderGradient" : "#2965FB"}
      />)
  }

  return (
    <HomeLayout>
      <HomeHeader heading="Hello, Sam. You’ve spent $405 in the last week." isHeaderCaption={false} />
      {showCarouselScreenShow &&
        <MemnershipEnrollmentScreens />}
      <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%] animate__animated animate__fadeInRight  '>
        <DynamicCard
          header={true}
          footer={false}
          CardRadius={true}
          HeaderRadius={true}
          cardWidth={width.homeCard}
          isWhite={appThemeData.isWhiteBgForCard}
          isDarkForKudzu={appThemeData.isDarkBgForCard}
          backgroundColor={'--cardHeading-bg'}
          HeaderContent={
            <>
              <CardHeading image={appThemeData.isBlueIconForSavings} heading={SAVINGS} />
            </>
          }

        >
          {/* <div className=" lg:my-[2rem] md:my-[1.5rem] my-[1.5rem] font-[500] 
        lg:text-[26px] md:text-[22px] 
        sm:text-[20px] text-[20px]
            leading-[36px] font-hanken-grotesk sm:mx-0 mx-4">
            {SAVINGS}
          </div> */}
          <AccountDetailsHeder
            AccountNo={checkingAccountNumber}
            routingNo={checkingRoutingNumber}
            accountCopiedProps={accountCopied}
            routingCopiedProps={routingCopied}
            handleCopyClick={accountNumberCopiedClicked}
            handleCopyRoutingNumberClick={routingNumberCopiedClicked}
            contentBetween={true}
            topBorder={appThemeData.borderTopForAccServices} 
            bottomBorder={true}
            isCopyblack={true}
          />

          <QuickActions actionsArray={QuickActionsButtons} />

          {/* /////more service */}
          <div className="border-t-[2.5px] border-[var(--transactions-acc-number-border)] 
          flex flex-col justify-center lg:mb-16 mb-0 sm:mx-0 mx-4">
            <MoreServices actionsArray={moreServicesArray} />
          </div>

        </DynamicCard>
        {footerContent()}
        {(!kudzuPlusTrue && isShowKudzuPlusPrompt) ? kudzuPlusSavings() : ""}
      </div>
      <CustomModalPlus isOpen={showPlusModal} onClose={closeModelPlus}
        image={modelImage}
        carousel={carousel}
        summaryParagraph={<p className={summaryParagraphStyles}>{summaryParagraph}</p>}
        isBorderNone={isBorderNone}
        highlightMsg={<p className={HeaderMsgStylesForPlus}> {headerMsg}</p>}
        subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
        btn1Exists={btn1Exists}
        btn2Exists={btn2Exists}
        btn1Text={btn1Text}
        btn1BgColor={btn1BgColor}
        btn2Text={btn2Text}
        opacityLow={opacityValueLow}
        defaultCornerRadius={false}
        btn1TypeAcpt={btn1TypeAcpt}
        onAcptBtnClick={onAcptBtnClickPlusModal}
        onCancelBtnClick={onCancelBtnClickPlusModal}
        gradientButton={gradientButton}
        largeImage={largeImage}
        btn2TextColor={'#779CE5'}
      />
    </HomeLayout>
  )
}
export default AccountServicesSavingsCard;